// ACCORDION /////////////

export function Accordion() {

	this.target;
	var jsAccordion;

	var defaults = {
		speed: 300,
		target: ".js-accordion",
	}

	var target = document.querySelector(defaults.target);

	// Create options by extending defaults with the passed in arugments
	if (arguments[0] && typeof arguments[0] === 'object') {
		this.options = extendDefaults(defaults, arguments[0]);
	}

	this.init(target);

	//
	//PRIVATE METHODS
	//
	// Utility method to extend defaults with user options
	function extendDefaults(source, properties) {
		var property;
		for (property in properties) {
			if (properties.hasOwnProperty(property)) {
				source[property] = properties[property];
			}
		}
		return source;
	}
}

Accordion.prototype.slideUp = function (target) {

		var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		window.setTimeout(function () {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	},

	Accordion.prototype.slideDown = function (target) {

		var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
		target.style.removeProperty('display');
		var display = window.getComputedStyle(target).display;
		if (display === 'none') display = 'block';
		target.style.display = display;
		var height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		window.setTimeout(function () {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}

Accordion.prototype.slideToggle = function (target) {

	var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

	if (window.getComputedStyle(target).display === 'none') {
		return this.slideDown(target, duration);
	} else {
		return this.slideUp(target, duration);
	}
}

Accordion.prototype.vanillaToggle = function (target) {
	var _this = this;
	var closestAccordion = target.closest('.js-accordion');
	var findActiveItem = closestAccordion.querySelectorAll(".js-accordion__item.active");

	// show/hide the clicked accordion item
	if (target.closest('.js-accordion__item').classList.contains('active')) {
		target.closest('.js-accordion__item').classList.remove('active');
	} else {
		findActiveItem.forEach(function (item) {
			_this.slideUp(item.querySelector(".js-accordion__body"));
			item.classList.remove("active");
		});
		target.closest('.js-accordion__item').classList.add('active');
	}
	this.slideToggle(target);
}

Accordion.prototype.init = function (target) {
	var _this = this;
	var jsAccordion = document.querySelectorAll('.js-accordion');

	jsAccordion.forEach(function (thisAccordion) {
		var accordionHeader = thisAccordion.querySelectorAll('.js-accordion__header');
		var accordionItem = thisAccordion.querySelectorAll('.js-accordion__item');

		accordionHeader.forEach(function (header) {
			header.addEventListener("click", function () {

				var closestAccordion = this.closest('.js-accordion');
				var closestItem = this.closest('.accordion__item');
				var findItem = this.closest(".js-accordion__item")
				var findBody = closestItem.querySelector(".accordion__body");

				_this.vanillaToggle(findBody);
			});
		});
	});
}